export const formatDateToEnUs = (dateStr: string): string => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

export const formatDateForTimezone = (date: string, timeZone: string): string =>
  new Date(date).toLocaleString('en-US', { timeZone });
